import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { RiCloseFill } from '@remixicon/react';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { toggleScroll } from '../../../helpers/utils';
import { SuccessTooltip } from '../../Icons/SuccessTooltip';
import { WarningTooltip } from '../../Icons/WarningTooltip';

type ModalProps = {
	id: string;
	open: boolean;
	onClose: () => void;
	children: React.ReactNode;
	infoIcon: 'warning' | 'success' | 'rules' | '';
};

const ModalToolTipWithdraw = ({
	open,
	onClose,
	children,
	id,
	infoIcon = 'warning',
}: ModalProps) => {
	useEffect(() => {
		toggleScroll(open);
		App.addListener('backButton', (event) => {
			if (open) {
				onClose();
			}
		});

		if (open) {
			setTimeout(() => {
				const modalContent = document.querySelector(
					`#${id} .overflow-y-auto`
				);
				if (modalContent) {
					modalContent.scrollTop = 0;
				}
			}, 10);
		}

		return () => document.body.classList.remove('overflow-hidden');
	}, [open]);
	const container: any = document.getElementById('main-content');

	if (!open) return null;

	return ReactDOM.createPortal(
		<div
			id={id}
			onClick={(e) => {
				e.stopPropagation();
				e.preventDefault();
				onClose();
			}}
			className={
				'fixed z-[9999999] inset-0 flex justify-start items-start pt-10 transition-colors ' +
				(Capacitor.getPlatform() === 'ios'
					? 'pt-safe-offset-10 '
					: ' ') +
				(open ? 'visible bg-custom-gray1/70' : 'invisible')
			}
		>
			<div
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
				}}
				className={
					`w-full max-h-[80vh] lg:max-w-[800px] overflow-y-auto lg:mx-auto mx-4 p-6 bg-custom-white rounded-xl shadow transition-all ${
						open ? 'opacity-100' : 'opacity-0'
					}` + (Capacitor.getPlatform() === 'ios' ? 'pt-safe' : '')
				}
			>
				<div className="flex flex-col overflow-y-auto">
					<div className="flex flex-row justify-between pb-2 items-center">
						<div>
							{infoIcon === 'success' && <SuccessTooltip />}
							{infoIcon === 'warning' && <WarningTooltip />}
							{infoIcon === 'rules' && <WarningTooltip />}
						</div>
						<button
							onClick={onClose}
							className="rounded-lg text-gray-400 bg-white hover:bg-gray-50 hover:text-gray-600 flex"
						>
							<RiCloseFill fontSize={12} color="#717680" />
						</button>
					</div>

					<div>{children}</div>
				</div>
			</div>
		</div>,
		container
	);
};

export default ModalToolTipWithdraw;
